module.exports = __webpack_public_path__ + "30858cd311706d1295d8874519514e13.png";